const StringIsNumber = (value: string) => isNaN(Number(value)) === false;

export const EnumToArray = (x: any) => {
  return Object.keys(x)
    .filter(StringIsNumber)
    .map(key => x[key]);
};
